
import { defineComponent } from "vue";
import { Header } from "@/types";
import Donations from "./DonationsTable.vue";

export default defineComponent({
  name: "TransactionItem",
  components: {
    Donations,
  },
  props: {
    role: {
      type: String,
      required: true,
    },
    windowWidth: {
      type: Number,
      required: true,
    },
    transaction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { key: "name", label: "Food Item Name" },
        { key: "type", label: "Food Type" },
        { key: "stage", label: "Life Cycle Stage" },
        { key: "quantity", label: "Quantity" },
        { key: "weight", label: "Weight" },
      ] as Header[],
    };
  },
  methods: {
    setURL(image: string): string {
      const urlcheck = /^(ftp|http|https):\/\/[^ "]+$/;
      return RegExp(urlcheck).exec(image)
        ? image
        : require("@/assets/images/Shared/" + image);
    },
    truncateText(text: string): string {
      const truncated = text.length > 6 ? text.substring(0, 6) + "..." : text;
      return this.windowWidth > 576 ? text : truncated;
    },
    getDate(dateString: string): string {
      const date = new Date(dateString);
      const month =
        this.windowWidth > 576
          ? date.toLocaleString("default", { month: "long" })
          : date.getMonth();
      const day = date.getDate();
      const year = date.getFullYear();
      return this.windowWidth > 576
        ? `${month} ${day}, ${year}`
        : `${month}/${day}/${year}`;
    },
    getTime(dateString: string): string {
      const date = new Date(dateString);
      const hours = date.getHours() % 12;
      const minutes =
        date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      const meridiem = date.getHours() < 12 ? "AM" : "PM";
      return `${hours}:${minutes} ${meridiem}`;
    },
  },
  computed: {
    avatar: function (): string {
      return this.role === "Charity"
        ? this.transaction.donorAvatar
        : this.transaction.charityAvatar;
    },
  },
});
